import React, { Fragment } from "react";
import { Pressable, ScrollView, Text, View } from "react-native";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "../utils/convex-api";
import { useRouter } from "expo-router";
import { Avatar } from "../ui/avatar";
import { useSheet } from "../shared/sheet-provider";
import type {
  ParentConnectSheetPayload,
  ParentConnectSheetResult,
} from "../sheets/parent-connect-sheet";
import { SheetIds } from "../utils/sheet-ids";

function TutorStudents() {
  const { data: chats = [] } = useQuery(
    convexQuery(api.tutor.inbox.queries.getChats, {})
  );
  const router = useRouter();
  const { open } = useSheet<
    ParentConnectSheetPayload,
    ParentConnectSheetResult
  >(SheetIds.PARENT_CONNECT);

  if (chats.length === 0) {
    return <Fragment />;
  }

  return (
    <View className="mt-4">
      <Text className="font-geologica-medium font-medium text-[20px] text-gray-800 leading-[1.5]">
        Your Students
      </Text>

      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerClassName="gap-4 py-4 px-5"
        style={{ marginHorizontal: -20 }}
      >
        {chats.map((chat) => (
          <Pressable
            key={chat._id}
            className="h-[149] py-[24px] px-[23px] rounded-[12px] bg-white shadow-sm justify-center items-center gap-3"
            onPress={async () => {
              const result = await open({
                inTouchWith: chat.title,
                studentName: chat.studentName,
                studentId: chat.studentId,
              });
              if (result) {
                router.push(`/(app)/chat/${chat._id}`);
              }
            }}
          >
            <Avatar size="md">
              <Avatar.Content
                size="md"
                label={chat.studentName}
                labelSize="md"
                source={
                  chat.studentImageUrl
                    ? { uri: chat.studentImageUrl }
                    : undefined
                }
              />
            </Avatar>
            <Text
              className="text-base leading-[24px] font-geologica-regular font-normal text-gray-800"
              numberOfLines={1}
            >
              {chat.studentName}
            </Text>
          </Pressable>
        ))}
      </ScrollView>
    </View>
  );
}

export default TutorStudents;
